module.exports = __webpack_public_path__ + "70d8bae3b6c00d7b9e7c03db54566189.woff2";